export enum Layout {
  Gallery = 'gallery',
  List = 'list',
  SmartGrid = 'smartGrid',
}

export enum SettingsLayout {
  GalleryWithPanel = 'galleryWithPanel',
  ListWithPanel = 'listWithPanel',
}
